<template>
  <div class="grid">
    <div class="col-12">
      <Card>
        <template #title>{{ title ? title : 'Отчеты на перевыгрузку КИ' }}</template>
        <template #content>
          <AbstractTable ref="table" code="correctionReports" :default-data="{eventId: eventId, reportId: reportId}" display-filter="menu">
            <template #additionalButtons>
              <Button
                icon="pi pi-refresh"
                class="p-button-rounded p-button-outlined"
                @click="$refs.table.getData()"
              ></Button>
            </template>
            <template #id="row">
              <IdChip
                view="resend_loan_view"
                :id="row.data.id"
                :menu-items="generateItems(row.data)"
                toast-template='Идентификатор отчёта на перевыгрузку КИ "{v}" скопирован'
              />
            </template>
            <template #bureau="row">
              {{ $filters.translate($store, 'deleteInformationPartBureaus', row.data.bureau) }}
            </template>
            <template #status="row">
              <StatusChip
                :value="row.data.status"
                compendium="processStatuses"
              />
            </template>
            <template #filename="row">
              <ValueChip
                v-if="row.data.filename"
                :value="row.data.filename"
                toast-template='Имя файла отчёта на корректировку "{v}" скопировано'
              />
            </template>
          </AbstractTable>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import AbstractTable from "@/components/AbstractTable.vue";
import ValueChip from "@/components/Common/ValueChip.vue";
import IdChip from "@/components/Common/IdChip.vue";
import StatusChip from "@/components/Common/StatusChip.vue";
import ResendLoanActions from "@/helpers/actions/resendLoanActions";

export default {
  name: 'CorrectionReportsTable',
  components: {StatusChip, IdChip, ValueChip, AbstractTable},
  props: {
    title: {
      type: String
    },
    reportId: {
      type: Number
    },
    eventId: {
      type: Number
    }
  },
  methods: {
    generateItems(data) {
      const actions = new ResendLoanActions(data);

      actions.beforeResend = () => this.$refs.table.setLoading(true);
      actions.afterResend = () => this.refresh();

      return actions.getMenuItems();
    },
    refresh() {
      this.$refs.table.getData();
    }
  }
}
</script>


